if (!customElements.get('offer-price-display')) {
  customElements.define(
    'offer-price-display',
    class OfferPriceDisplay extends HTMLElement {
      constructor() {
        super();

        this.strikethroughEl = this.querySelector('.offer-price__strikethrough');
        this.valueEl = this.querySelector('.offer-price__value');

        this.initialStrikethroughPrice = this.strikethroughEl?.textContent?.trim() || '';
        this.initialValuePrice = this.valueEl?.textContent?.trim() || '';

        this.handleProductSelectedBound = this.handleProductSelected.bind(this);
        document.addEventListener('product-selected', this.handleProductSelectedBound);
      }

      disconnectedCallback() {
        document.removeEventListener('product-selected', this.handleProductSelectedBound);
      }

      handleProductSelected(event) {
        const eventSectionId = event.target.closest('offer-section')?.dataset.sectionId;
        if (eventSectionId !== this.dataset.sectionId) return;

        const { sellingPlanId, sellingPlanPrice, oneTimePrice, upsellSellingPlanPrice, upsellOneTimePrice } =
          event.detail || {};
        const isOneTimePurchase = sellingPlanId === '' || sellingPlanId === undefined;

        const valuePrice = isOneTimePurchase
          ? upsellOneTimePrice || oneTimePrice || this.initialValuePrice
          : upsellSellingPlanPrice || sellingPlanPrice || this.initialValuePrice;
        const compareAtPrice = isOneTimePurchase
          ? ''
          : upsellOneTimePrice || oneTimePrice || this.initialStrikethroughPrice;

        this.updatePrice(compareAtPrice, valuePrice);
      }

      updatePrice(compareAtPrice, valuePrice) {
        if (this.valueEl && valuePrice) {
          this.valueEl.textContent = valuePrice;
        }

        if (!this.strikethroughEl) return;

        if (compareAtPrice) {
          this.strikethroughEl.textContent = compareAtPrice;
          this.strikethroughEl.hidden = false;
          return;
        }

        this.strikethroughEl.hidden = true;
      }
    },
  );
}
